import React from "react";
import clsx from "clsx";

import {withStyles} from "@material-ui/core";
import Button from "@material-ui/core/Button";

import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import BaseDialog from "../../../../components/BaseDialog/BaseDialog";

import styles from "./styles";


class ConfirmationDialog extends React.Component {

  render() {

    const { classes, customClasses } = this.props;
    return (
      <BaseDialog
        title={this.props.title}
        maxWidth='sm'
        disableBackdropClick
        open={this.props.open}
        handleClose={this.props.onCancel}
        modalLoading={this.props.loading}
        customClasses={customClasses}
        actions={
          <div className={classes.buttonsRow}>
            <Button
              className={clsx(classes.buttonCancel, classes.button, customClasses.buttonCancel)}
              disableRipple={true}
              onClick={this.props.onClose}
            >
              {this.props.rejectButtonText || 'Abbrechen'}
            </Button>
            <PrimaryButton
              text={this.props.confirmButtonText || 'Ja'}
              classes={{button: clsx(classes.button, customClasses.buttonConfirm)}}
              onButtonClick={this.props.confirm}
            />
          </div>
        }
      >
        <div className={clsx(classes.messageContent, customClasses.messageContent)}>
          {this.props.message}
        </div>
      </BaseDialog>
    )
  }
}

ConfirmationDialog.defaultProps = {
  customClasses: {}
};

export default withStyles(styles)(ConfirmationDialog);
